/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".customer-filter[_ngcontent-%COMP%]{margin:12px 0}.customer-filter__button[_ngcontent-%COMP%]{min-width:120px}.customer-filter__conditions[_ngcontent-%COMP%]{margin-top:8px;font-size:12px;line-height:1.5;word-break:break-word}"];
export { styles as styles };
